<script setup lang="ts">
import { type FieldProps, useFieldValidation } from '@/composables/useFieldValidation';

const props = defineProps<FieldProps>();

const {
  value,
  errorMessage,
  fieldId,
  isDisabled,
  handlers,
  computedLabel: label
} = useFieldValidation(props);
</script>

<template>
  <div class="fieldBlock fieldBlock_input">
    <label :for="fieldId">
      {{ label }}
    </label>
    <input :id="fieldId"
           v-model="value"
           :type="props.type || 'text'"
           :aria-invalid="!!errorMessage"
           :disabled="isDisabled"
           :maxlength="props.maxLength"
           v-on="handlers">
    <div class="fieldBlock-extraInfo">
      <span v-if="errorMessage"
            class="fieldBlock-error">{{ errorMessage }}</span>
      <span v-if="props.hint"
            class="fieldBlock-hint">
        {{ props.hint }}
      </span>
    </div>
  </div>
</template>
